<template>
  <button id="NUMBER_5" name="5" class="btn num-btn" data-vcode="NUMBER_5" aria-label="5 JKL">
    <div class="digit">5</div>
    <div class="letters">JKL</div>
  </button>
</template>
<script>
export default {};
</script>
